<style>
.green-percent {
    font-size: 13px; 
    color: white; 
    background-color: #19be6f !important; 
    padding: 2px 4px;
}
  
.yellow-percent {
    font-size: 13px; 
    color: black; 
    background-color: #FFD600 !important; 
    padding: 2px 4px;
}
  
.red-percent {
    font-size: 13px; 
    color: white; 
    background-color: #fa594f !important; 
    padding: 2px 4px;
}
</style>

<template>
    <v-card elevation="0" class="mb-15">
        <v-container style="max-width: 1680px;" class="container-side-padding">
        <v-row class="ma-0 pa-0 container-side-padding mt-5 mt-sm-10">
            <v-breadcrumbs class="pa-0 diia-nav-breadcrumbs" :items="breadcrumbs_navigation_items">
                <template v-slot:divider>
                <span color="black">|</span>
                </template>
            </v-breadcrumbs>
        </v-row>
        <v-row class="mt-xs-2 mt-md-7">
            <v-col cols="12" md="8" order="3" order-sm="3" order-md="1">
    
                <h3 class="diia-h3-header" v-if="show_detail_org" ref="detail_info">Статистика та наповнення організації</h3>
                <h3 class="diia-h3-header" v-if="show_detail_irs" ref="detail_info">Статистика та наповнення е-ресурсу</h3>
                <h3 class="diia-h3-header" v-if="show_detail_sub" ref="detail_info">Статистика та наповнення підсистеми</h3>
                <h3 class="diia-h3-header" v-if="show_detail_intf" ref="detail_info">Статистика та наповнення програмного інтерфейсу е-ресурсу</h3>
                <h3 class="diia-h3-header" v-if="show_detail_srv" ref="detail_info">Статистика та наповнення сервісу</h3>
                <h3 class="diia-h3-header" v-if="show_detail_itr" ref="detail_info">Статистика та наповнення взаємодії</h3>
                <h3 class="diia-h3-header" v-if="show_detail_server" ref="detail_info">Статистика та наповнення шлюзу безпечного обміну</h3>
                <span class="diia-nav-breadcrumbs" style="opacity: 0.7;">Промислове та тестове середовища</span>


                <div style="display: flex; align-items: center; margin-top: 24px;">
                    <v-btn class="btn_outlined_diia small" @click="onClickReturnToOrganization">
                        <v-icon>mdi-format-list-checkbox</v-icon>
                        <span style="margin-left: 8px;">Про організацію</span>
                    </v-btn>
                </div>

                <v-data-table
                    dense
                    locale="uk-UA"
                    :headers="general_overview_headers"
                    :items="general_overview_data"
                    disable-pagination
                    disable-sort
                    disable-filtering
                    hide-default-footer
                    hide-default-header
                    :loading="detail_loading"
                    mobile-breakpoint="1"
                    class="elevation-0 pa-0 data-table-detail-design fifty-table mt-10"
                >
                    <template v-slot:item.value="{ item }">
                        <a v-if="item.type == 'link'" v-bind:href="item.value" target="_blank" class="view-href-a">Переглянути</a>
                        <a v-else-if="item.type == 'file'" v-bind:href="$config.backend_url + item.value" target="_blank" class="view-href-a">{{ item.auth_required && !authData ? 'Необхідна авторизація' : 'Завантажити' }}</a>
                        <span v-else-if="item.type == 'boolean' && item.value == true">Так</span>
                        <span v-else-if="item.type == 'three-colored-percent'" :class="parseFloat(item.value.slice(0, -1)) < 50 ? 'red-percent' : (parseFloat(item.value.slice(0, -1)) > 80 ? 'green-percent' : 'yellow-percent')">{{ item.value }}</span>
                        <span v-else-if="item.type == 'boolean' && item.value == false">Ні</span>
                        <!-- <a v-if="item.fat == 'Завантажити'" href="https://directory-test.trembita.gov.ua/api/wsdl/SEVDEIR-TEST/GOV/38068238/62_LymanRTG_prod/InfMsgReceiver" target="_blank" class="view-href-a">Завантажити</a> -->
                        <span v-else> {{ item.value }} </span>
                    </template>
                </v-data-table>
    
                <v-divider class="mt-10 mb-10 v-divider-light"></v-divider>
    
                <!-- STATS TAB -->
                <h3 class="mb-10 diia-h3-header" ref="detail_issues_stats">Аналітика проблем</h3>
    
                <v-data-table
                    dense
                    locale="uk-UA"
                    :headers="general_issues_stats_headers"
                    :items="general_issues_stats_data"
                    disable-pagination
                    disable-sort
                    disable-filtering
                    hide-default-footer
                    hide-default-header
                    :loading="stats_loading"
                    mobile-breakpoint="1"
                    class="elevation-0 pa-0 data-table-detail-design fifty-table"
                ></v-data-table>
    
                <v-divider class="mt-10 mb-10 v-divider-light"></v-divider>
            </v-col>
            <v-col cols="12" md="1" order="2" class="d-none d-md-block"></v-col>
            <v-col cols="12" md="3" order="1" order-sm="1" order-md="3">
                <div style="position: sticky; top: 20px;">
                    <span class="mt-2" style="line-height: 1.2; font-size: 20px;">Навігація по сторінці</span>
                    <v-divider style="background-color: black; border-width: 1px;" class="mt-5 mb-1"></v-divider>
                    <v-list dense>
                        <v-list-item-group
                            v-model="selectedItem"
                            color="primary"
                        >
                            <v-list-item
                                class="pa-0 diia-side-nav-item" v-ripple="false"
                                @click="goto('detail_info')">
                                <v-list-item-content>
                                    <v-list-item-title style="line-height: 1.5; font-size: 15px; font-weight: 400;">Статистика та наповнення
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
    
                            <v-list-item
                                class="pa-0 diia-side-nav-item" v-ripple="false"
                                @click="goto('detail_issues_stats')">
                                <v-list-item-content>
                                    <v-list-item-title style="line-height: 1.5; font-size: 15px; font-weight: 400;">Аналітика проблем
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>

                            <v-list-item
                                class="pa-0 diia-side-nav-item" v-ripple="false"
                                @click="goto('detail_issues')">
                                <v-list-item-content>
                                    <v-list-item-title style="line-height: 1.5; font-size: 15px; font-weight: 400;">Деталі
                                    </v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list-item-group>
                    </v-list>
                </div>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" order="3">
                <!-- <h3 class="mb-10 diia-h3-header" ref="detail_stats">Деталі</h3>
                    <v-data-table
                        dense
                        locale="uk-UA"
                        :headers="detailed_issues_description_headers"
                        :items="detailed_issues_description_data"
                        disable-pagination
                        disable-sort
                        disable-filtering
                        hide-default-footer
                        hide-default-header
                        :loading="stats_loading"
                        mobile-breakpoint="1"
                        class="elevation-0 pa-0 data-table-detail-design fifty-table"
                ></v-data-table> -->


                <template>
                    <h3 class="mb-10 diia-h3-header" ref="detail_issues">Деталі</h3>
                    <v-row class="ma-0 pa-0">
                        <v-text-field
                            v-if="detailed_issues_description_data.length > 0"
                            v-model="detailed_issues_description_data_search"
                            label="Пошук по таблиці"
                            append-icon="mdi-magnify"
                            class="ma-0 pa-0 v-colored-search"
                        ></v-text-field>
                        <v-select
                            v-model="detailed_issues_description_type_filter"
                            class="pa-0 ml-6 mt-0 mr-0 mb-0 v-colored-search"
                            label="За типом"
                            :items="detailed_issues_filters"
                            single-line
                            clearable
                            item-value="key"
                            item-text="value"
                        >
                        </v-select>
                    </v-row>
                    <v-data-table
                        dense
                        locale="uk-UA"
                        :hide-default-footer="detailed_issues_description_data.length == 0"
                        :hide-default-header="detailed_issues_description_data.length == 0"
                        :footer-props="{'items-per-page-options':[4, 10, 25, 50]}"
                        :headers="detailed_issues_description_headers"
                        :items="detailed_issues_list"
                        :loading="interfaces_list_loading"
                        :items-per-page="10"
                        no-data-text="Відсутні"
                        mobile-breakpoint="1"
                        class="elevation-0 pa-0 data-table-detail-design"
                    ></v-data-table>
                    <v-divider class="mt-10 mb-10 v-divider-light"></v-divider>
                </template>
            </v-col>
        </v-row>
        </v-container>
    </v-card>
    </template>
    
    <script>
    /* eslint-disable */
    import axios from "axios";
    import { mapState } from 'vuex';
    import clib from "../js/common_lib"
    
    export default {
      name: "CatalogItemDetailPage",
      data: () => ({
        breadcrumbs_navigation_items: [],
    
        detail_loading: false,
        stats_loading: false,
        documentation_loading: false,
        information_resources_list_loading: false,
        subsystems_list_loading: false,
        interfaces_list_loading: false,
        services_list_loading: false,
        interactions_list_loading: false,
        exchanges_list_loading: false,
    
        show_tables: true,
        show_tables_org: true,
        show_tables_irs: false,
        show_tables_sub: false,
        show_tables_intf: false,
        show_tables_srv: false,
        show_tables_exch: false,
    
        display_members_entities: true,
    
        show_detail_org: true,
        show_detail_irs: false,
        show_detail_sub: false,
        show_detail_intf: false,
        show_detail_srv: false,
        show_detail_itr: false,
        show_detail_server: false,
    
        main_list_search: "",
        subsystems_data_search: "",
        interfaces_data_search: "",
        services_data_search: "",
        interactions_data_search: "",
        exchanges_data_search: "",
    
        detail_data_response: {},
        selectedItem: "",
    
        general_overview_headers: [{
            align: 'start',
            value: 'field',
            class: 'data-table-header',
            width: "50%"
        }, { 
            align: 'start',
            value: 'value',
            class: 'data-table-header',
            width: "50%"
        }],
        general_overview_data: [],
    
        general_issues_stats_headers: [
          {
            align: 'start',
            value: 'field',
            class: 'data-table-header fifty-width',
          },
          {
            align: 'start',
            value: 'value', 
            class: 'data-table-header fifty-width',
          },
        ],
        general_issues_stats_data: [],
    
        detailed_issues_description_headers: [],
        detailed_issues_description_data: [],
        detailed_issues_filters: [],
        detailed_issues_description_type_filter: "",

        detailed_issues_description_data_search: "",
    
      }),
      created: function () {
        document.title = this.$route.meta && this.$route.meta.title ? this.$route.meta.title : 'Каталог системи Трембіта';
    
        this.fetchServerData();
        this.setBreadcrumbsNavigation();
      },

      mounted: function() {
        if (this.$route.query.details_type_filter) {
            this.detailed_issues_description_type_filter = this.$route.query.details_type_filter;
        }
      },
    
      computed: {
        ...mapState(['authData']),

        detailed_issues_list: function() {
            let search_applied = clib.imprecizeComparison(this.detailed_issues_description_data_search, this.detailed_issues_description_data);
            console.log(search_applied);
            return this.detailed_issues_description_type_filter ? search_applied.filter(item => item.filter == this.detailed_issues_description_type_filter) : search_applied;
        },
      },
    
      watch: {
          $route(to, from) {
            if (to.name == 'organization-analytics-info') {
                document.title = (to.meta && to.meta.title) ? to.meta.title : 'Каталог системи Трембіта';
                this.fetchServerData();
                this.setBreadcrumbsNavigation();

                console.log("TO QUERY");
                console.log(to.query);
                console.log(to.query_params);

                if (to.query.details_type_filter)
                    this.detailed_issues_description_type_filter = to.query.details_type_filter;
            }
          }
      },
      
      methods: {
        onClickReturnToOrganization(value) {
            this.$router.push({ name: 'organization-detail-info', params: { id: this.$route.params.id }, query: this.$config.query_params });
        },
        fetchServerData() {
            if (this.$route.name == 'organization-analytics-info') {
                this.onClickMainOrganizationInit();
    
                // this.general_issues_stats_headers = this.$config.configuration.organization.analytics.display.general_issues_stats;
                this.detailed_issues_description_headers = this.$config.configuration.organization.analytics.display.detailed_issues_description;
    
                this.fetchIssues(this.$config.configuration.organization.analytics.endpoints.issues.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            }
            else if (this.$route.name == 'information-resource-detail-info') {
                this.onClickDetailIrsInit();
    
                this.subsystems_headers = this.$config.configuration.information_resource.detail.display.subsystems;
                this.interfaces_headers = this.$config.configuration.information_resource.detail.display.interfaces;
                this.services_headers = this.$config.configuration.information_resource.detail.display.services;
                this.interactions_headers = this.$config.configuration.information_resource.detail.display.interactions;
    
                this.fetchDetailInformationResource(this.$config.configuration.information_resource.detail.endpoints.detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchSubsystems(this.$config.configuration.information_resource.detail.endpoints.subsystems.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchInterfaces(this.$config.configuration.information_resource.detail.endpoints.interfaces.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchServices(this.$config.configuration.information_resource.detail.endpoints.services.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchInteractions(this.$config.configuration.information_resource.detail.endpoints.interactions.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            }
            else if (this.$route.name == 'subsystem-detail-info') {
                this.onClickDetailSubInit();
    
                this.interfaces_headers = this.$config.configuration.subsystem.detail.display.interfaces;
                this.services_headers = this.$config.configuration.subsystem.detail.display.services;
                this.interactions_headers = this.$config.configuration.subsystem.detail.display.interactions;
    
                this.fetchDetailSubsystem(this.$config.configuration.subsystem.detail.endpoints.detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchInterfaces(this.$config.configuration.subsystem.detail.endpoints.interfaces.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchServices(this.$config.configuration.subsystem.detail.endpoints.services.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchInteractions(this.$config.configuration.subsystem.detail.endpoints.interactions.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            }
            else if (this.$route.name == 'interface-detail-info') {
                this.onClickDetailInterfaceInit();
    
                this.documentation_headers = this.$config.configuration.information_resource_interface.detail.display.documentation;
                this.services_headers = this.$config.configuration.information_resource_interface.detail.display.services;
                this.interactions_headers = this.$config.configuration.information_resource_interface.detail.display.interactions;
    
                this.fetchDetailInterface(this.$config.configuration.information_resource_interface.detail.endpoints.detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchDocumentation(this.$config.configuration.information_resource_interface.detail.endpoints.documentation.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchServices(this.$config.configuration.information_resource_interface.detail.endpoints.services.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchInteractions(this.$config.configuration.information_resource_interface.detail.endpoints.interactions.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            
                console.log(this.authData);
            }
            else if (this.$route.name == 'service-detail-info') {
                this.onClickDetailSrvInit();
                this.fetchDetailService(this.$config.configuration.service.detail.endpoints.detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchStats(this.$config.configuration.service.detail.endpoints.stats.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id), {
                    "exchanges_good_total": "Всього успішних обмінів з початку роботи системи"
                });
            }
            else if (this.$route.name == 'interaction-detail-info') {
                this.onClickDetailItrInit();
    
                this.exchanges_headers = this.$config.configuration.interaction.detail.display.exchanges;
    
                this.fetchDetailInteraction(this.$config.configuration.interaction.detail.endpoints.detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchExchanges(this.$config.configuration.interaction.detail.endpoints.exchanges.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            }
            else if (this.$route.name == 'server-detail-info') {
                this.onClickDetailServerInit();
    
                this.server_headers = this.$config.configuration.server.detail.display.exchanges;
                this.subsystems_headers = this.$config.configuration.server.detail.display.subsystems;
                this.services_headers = this.$config.configuration.server.detail.display.services;
                
                this.fetchDetailServer(this.$config.configuration.server.detail.endpoints.detail.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchSubsystems(this.$config.configuration.server.detail.endpoints.subsystems.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
                this.fetchServices(this.$config.configuration.server.detail.endpoints.services.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            
                
                // this.fetchExchanges(this.$config.configuration.interaction.detail.endpoints.exchanges.replace(':backend_url', this.$config.backend_url).replace(':id', this.$route.params.id));
            }
        },

        fetchIssues(url) {
            this.detail_loading = true;
            this.detail_data_response = {};
    
            axios({
                method: "get",
                url: url,
            })
            .then((response) => {
                this.general_issues_stats_data = [];
                this.detailed_issues_description_data = [];
                for (let item in response.data.stats) {
                    let result = this.$clib.transformDetailItem(item, response.data.stats, this.$config.configuration.organization.analytics.display.general_issues_stats, this.$config.query_params.env);
    
                    if (result) {
                        this.general_issues_stats_data.push(result);
                    }
                }

                for (let item in response.data.stats) {
                    let result = this.$clib.transformDetailItem(item, response.data.stats, this.$config.configuration.organization.analytics.display.general_overview, this.$config.query_params.env);
    
                    if (result) {
                        this.general_overview_data.push(result);
                    }
                }

                for (let item in response.data.details.services_without_interfaces) {
                    response.data.details.services_without_interfaces[item]["filter"] = "services_without_interfaces"
                    this.detailed_issues_description_data.push(response.data.details.services_without_interfaces[item]);
                }
                for (let item in response.data.details.not_updated_eresources) {
                    response.data.details.not_updated_eresources[item]["filter"] = "not_updated_eresources"
                    this.detailed_issues_description_data.push(response.data.details.not_updated_eresources[item]);
                }
                for (let item in response.data.details.subsystems_without_eresources) {
                    response.data.details.subsystems_without_eresources[item]["filter"] = "subsystems_without_eresources"
                    this.detailed_issues_description_data.push(response.data.details.subsystems_without_eresources[item]);
                }

                this.detailed_issues_filters = response.data.details_filters;
            })
            .catch((error) => {
                if (error.response.status == 404) {
                    this.$router.replace({ name: 'notFound', query: this.$config.query_params });
                }
            })
            .finally(() => {
                this.detail_loading = false;

                if (this.$route.query.details_type_filter) {
                    this.detailed_issues_description_type_filter = this.$route.query.details_type_filter;
                    this.goto('detail_issues');
                }
            });
        },


















        fetchDetailInformationResource(url) {
            this.detail_loading = true;
            this.detail_data_response = {};
    
            axios({
                method: "get",
                url: url,
            })
            .then((response) => {
                this.detail_data = []
                for (let item in response.data) {
                    let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.information_resource.detail.items, this.$config.query_params.env);
    
                    if (result) {
                        this.detail_data.push(result);
                    }
                }
            })
            .catch((error) => {
                if (error.response.status == 404) {
                    this.$router.replace({ name: 'notFound', query: this.$config.query_params });
                }
            })
            .finally(() => {
                this.detail_loading = false;
            });
        },
    
        fetchDetailSubsystem(url) {
            this.detail_loading = true;
            this.detail_data_response = {};
    
            axios({
                method: "get",
                url: url
            })
            .then((response) => {
                this.detail_data = []
                this.detail_data_response = response.data;
                for (let item in response.data) {
                    let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.subsystem.detail.items, this.$config.query_params.env);
    
                    if (result) {
                        this.detail_data.push(result);
                    }
                }
            })
            .catch((error) => {
                if (error.response.status == 404) {
                    this.$router.replace({ name: 'notFound', query: this.$config.query_params });
                }
            })
            .finally(() => {
                this.detail_loading = false;
            });
        },
    
    
        fetchDetailInterface(url) {
            this.detail_loading = true;
            this.detail_data_response = {};
    
            axios({
                method: "get",
                url: url
            })
            .then((response) => {
                this.detail_data = []
                this.detail_data_response = response.data;
                for (let item in response.data) {
                    let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.information_resource_interface.detail.items, this.$config.query_params.env);
    
                    if (result) {
                        this.detail_data.push(result);
                    }
                }
            })
            .catch((error) => {
                if (error.response.status == 404) {
                    this.$router.replace({ name: 'notFound', query: this.$config.query_params });
                }
            })
            .finally(() => {
                this.detail_loading = false;
            });
        },
    
    
        fetchDetailService(url) {
            this.detail_loading = true;
            this.detail_data_response = {};
    
            axios({
                method: "get",
                url: url
            })
            .then((response) => {
                this.detail_data = []
                for (let item in response.data) {
                    let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.service.detail.items, this.$config.query_params.env);
    
                    if (result) {
                        this.detail_data.push(result);
                    }
                }
            })
            .catch((error) => {
                if (error.response.status == 404) {
                    this.$router.replace({ name: 'notFound', query: this.$config.query_params });
                }
            })
            .finally(() => {
                this.detail_loading = false;
            });
        },
    
    
        fetchDetailInteraction(url) {
            this.detail_loading = true;
            this.detail_data_response = {};
    
            axios({
                method: "get",
                url: url
            })
            .then((response) => {
                this.detail_data = [];
                for (let item in response.data) {
                    let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.interaction.detail.items, this.$config.query_params.env);
    
                    if (result) {
                        this.detail_data.push(result);
                    }
                }
            })
            .catch((error) => {
                if (error.response.status == 404) {
                    this.$router.replace({ name: 'notFound', query: this.$config.query_params });
                }
            })
            .finally(() => {
                this.detail_loading = false;
            });
        },
    
        fetchDetailServer(url) {
            this.detail_loading = true;
            this.detail_data_response = {};
    
            this.axiosSecure({
                method: "get",
                url: url
            })
            .then((response) => {
                this.detail_data = [];
                for (let item in response.data) {
                    let result = this.$clib.transformDetailItem(item, response.data, this.$config.configuration.server.detail.items, this.$config.query_params.env);
    
                    if (result) {
                        this.detail_data.push(result);
                    }
                }
            })
            .catch((error) => {
                if (error.response.status == 404) {
                    this.$router.replace({ name: 'notFound', query: this.$config.query_params });
                }
            })
            .finally(() => {
                this.detail_loading = false;
            });
        },
    
    
    
        fetchDocumentation(url) {
            this.documentation_loading = true;
    
            this.axiosSecure({
                method: "get",
                url: url,
            })
            .then((response) => {
                this.documentation_data = []
                for (let item in response.data) {
                    response.data[item].updated_at = this.$clib.dateFormatToUkrainian(response.data[item].updated_at);
                    this.documentation_data.push(response.data[item]);
                }
            })
            .catch((error) => {})
            .finally(() => {
                this.documentation_loading = false;
            });
        },
    
        fetchStats(url, translations) {
            this.stats_loading = true;
    
            axios({
                method: "get",
                url: url,
            })
            .then((response) => {
                this.stats_data = [];
                for (let item in response.data) {
                    let field = "";
                    let value = response.data[item];
    
                    if (item in translations) {
                        field = translations[item];
                    }
                    
                    if (item != "id")
                        this.stats_data.push({
                            "field": field,
                            "value": value,
                        })
                }
            })
            .catch((error) => {})
            .finally(() => {
                this.stats_loading = false;
            });
        },
    
    
    
    
    
    
    
        fetchInformationResources(url) {
            this.information_resources_list_loading = true;
    
            axios({
                method: "get",
                url: url,
            })
            .then((response) => {
                this.information_resources_data = [];
    
                for (let item in response.data) {
                    this.information_resources_data.push(response.data[item]);
                }
    
                this.stats_data.push({
                    field: "Зареєстрованих інформаційних е-ресурсів",
                    value: this.information_resources_data.length,
                });
            })
            .catch((error) => {})
            .finally(() => {
                this.information_resources_list_loading = false;
            });
        },
        fetchSubsystems(url) {
            this.subsystems_list_loading = true;
    
            axios({
                method: "get",
                url: url,
                params: {
                    instance: this.$config.query_params.env
                }
            })
            .then((response) => {
                this.subsystems_data = [];
    
                console.log(this.subsystems_data);
    
                for (let item in response.data) {
                    this.subsystems_data.push(response.data[item]);
                }
    
                this.stats_data.push({
                    field: "Зареєстрованих підсистем",
                    value: this.subsystems_data.length
                });
            })
            .catch((error) => {})
            .finally(() => {
                this.subsystems_list_loading = false;
            });
        },
        fetchInterfaces(url) {
            this.interfaces_list_loading = true;
    
            axios({
                method: "get",
                url: url,
            })
            .then((response) => {
                this.interfaces_data = []
    
                for (let item in response.data) {
                    this.interfaces_data.push(response.data[item]);
                }
    
                this.stats_data.push({
                    field: "Зареєстрованих інтерфейсів е-ресурсу",
                    value: this.interfaces_data.length
                });
            })
            .catch((error) => {})
            .finally(() => {
                this.interfaces_list_loading = false;
            });
        },
        fetchServices(url) {
            this.services_list_loading = true;
    
            axios({
                method: "get",
                url: url,
                params: {
                    instance: this.$config.query_params.env
                }
            })
            .then((response) => {
                this.services_data = []
    
                for (let item in response.data) {
                    this.services_data.push(response.data[item]);
                }
    
                this.stats_data.push({
                    field: "Опублікованих сервісів",
                    value: this.services_data.length
                });
            })
            .catch((error) => {})
            .finally(() => {
                this.services_list_loading = false;
            });
        },
    
    
        fetchInteractions(url) {
            this.interactions_list_loading = true;
    
            axios({
                method: "get",
                url: url,
                params: {
                    instance: this.$config.query_params.env
                }
            })
            .then((response) => {
                this.interactions_data = []
    
                for (let item in response.data) {
                    this.interactions_data.push(response.data[item]);
                }
    
                this.stats_data.push({
                    field: "Зареєстрованих взаємодій",
                    value: this.interactions_data.length
                });
            })
            .catch((error) => {})
            .finally(() => {
                this.interactions_list_loading = false;
            });
        },
    
    
        fetchExchanges(url) {
            this.exchanges_list_loading = true;
    
            axios({
                method: "get",
                url: url,
                params: {
                    instance: this.$config.query_params.env
                }
            })
            .then((response) => {
                this.exchanges_data = [];
    
                for (let item in response.data) {
                    this.exchanges_data.push(response.data[item]);
                }
    
                this.stats_data.push({
                    field: "Складових обмінів",
                    value: this.exchanges_data.length
                });
            })
            .catch((error) => {})
            .finally(() => {
                this.exchanges_list_loading = false;
            });
        },
    
        setBreadcrumbsNavigation() {
            const env_text = this.$route.query.env == 'SEVDEIR' ? '(пром)' : '(тест)';
    
            if (this.$route.name == 'organization-analytics-info') {
                this.breadcrumbs_navigation_items = [
                    {
                        text: 'Каталог',
                        disabled: false,
                        href: '/',
                    },
                    {
                        text: 'Організації ' + env_text,
                        disabled: false,
                        href: "/catalog/organizations/?env=" + this.$route.query.env,
                    },
                    {
                        text: 'Про організацію',
                        disabled: false,
                        href: this.$route.path + "?env=" + this.$route.query.env,
                    },
                    {
                        text: 'Аналітика',
                        disabled: false,
                        href: this.$route.path + "?env=" + this.$route.query.env,
                    },
                ]
            }
            else if (this.$route.name == 'information-resource-detail-info') {
                this.breadcrumbs_navigation_items = [
                    {
                        text: 'Каталог',
                        disabled: false,
                        href: '/',
                    },
                    {
                        text: 'Е-ресурси ' + env_text,
                        disabled: false,
                        href: "/catalog/information_resources/?env=" + this.$route.query.env,
                    },
                    {
                        text: 'Про е-ресурс',
                        disabled: false,
                        href: this.$route.path + "?env=" + this.$route.query.env,
                    },
                ]
            }
            else if (this.$route.name == 'subsystem-detail-info') {
                this.breadcrumbs_navigation_items = [
                    {
                        text: 'Каталог',
                        disabled: false,
                        href: '/',
                    },
                    {
                        text: 'Підсистеми ' + env_text,
                        disabled: false,
                        href: "/catalog/subsystems/?env=" + this.$route.query.env,
                    },
                    {
                        text: 'Про підсистему',
                        disabled: false,
                        href: this.$route.path + "?env=" + this.$route.query.env,
                    },
                ]
            }
            else if (this.$route.name == 'interface-detail-info') {
                this.breadcrumbs_navigation_items = [
                    {
                        text: 'Каталог',
                        disabled: false,
                        href: '/',
                    },
                    {
                        text: 'Інтерфейси е-ресурсів ' + env_text,
                        disabled: false,
                        href: "/catalog/interfaces/?env=" + this.$route.query.env,
                    },
                    {
                        text: 'Про інтерфейс е-ресурсу',
                        disabled: false,
                        href: this.$route.path + "?env=" + this.$route.query.env,
                    },
                ]
            }
            else if (this.$route.name == 'service-detail-info') {
                this.breadcrumbs_navigation_items = [
                    {
                        text: 'Каталог',
                        disabled: false,
                        href: '/',
                    },
                    {
                        text: 'Сервіси ' + env_text,
                        disabled: false,
                        href: "/catalog/services/?env=" + this.$route.query.env,
                    },
                    {
                        text: 'Про сервіс',
                        disabled: false,
                        href: this.$route.path + "?env=" + this.$route.query.env,
                    },
                ]
            }
            else if (this.$route.name == 'interaction-detail-info') {
                this.breadcrumbs_navigation_items = [
                    {
                        text: 'Каталог',
                        disabled: false,
                        href: '/',
                    },
                    {
                        text: 'Взаємодії ' + env_text,
                        disabled: false,
                        href: "/catalog/interactions/?env=" + this.$route.query.env,
                    },
                    {
                        text: 'Про взаємодію',
                        disabled: false,
                        href: this.$route.path + "?env=" + this.$route.query.env,
                    },
                ]
            }
            else if (this.$route.name == 'server-detail-info') {
                this.breadcrumbs_navigation_items = [
                    {
                        text: 'Каталог',
                        disabled: false,
                        href: '/',
                    },
                    {
                        text: 'Шлюзи безпечного обміну ' + env_text,
                        disabled: false,
                        href: "/catalog/servers/?env=" + this.$route.query.env,
                    },
                    {
                        text: 'Про шлюз безпечного обміну',
                        disabled: false,
                        href: this.$route.path + "?env=" + this.$route.query.env,
                    },
                ]
            }
        },
    
    
    
        clearTablesData() {
            this.detail_data = []
            this.stats_data = []
            this.documentation_data = []
            this.information_resources_data = []
            this.subsystems_data = []
            this.interfaces_data = []
            this.services_data = []
            this.interactions_data = []
        },
    
    
    
        onSearchEnter(val) {
            this.$config.query_params = this.$clib.clearQueryParams(this.$config.query_params)
    
            if (val == "org") {
                this.$config.query_params.search_org = this.main_list_search;
                this.$router.push({ name: 'organizations-list', query: this.$config.query_params });
            }
            if (val == "irs") {
                this.$config.query_params.search_irs = this.main_list_search;
                this.$router.push({ name: 'information-resources-list', query: this.$config.query_params });
            }
            if (val == "sub") {
                this.$config.query_params.search_sub = this.main_list_search;
                this.$router.push({ name: 'subsystems-list', query: this.$config.query_params });
            }
            if (val == "intf") {
                this.$config.query_params.search_intf = this.main_list_search;
                this.$router.push({ name: 'interfaces-list', query: this.$config.query_params });
            }
            if (val == "srv") {
                this.$config.query_params.search_srv = this.main_list_search;
                this.$router.push({ name: 'services-list', query: this.$config.query_params });
            }
            if (val == "itr") {
                this.$config.query_params.search_itr = this.main_list_search;
                this.$router.push({ name: 'interactions-list', query: this.$config.query_params });
            }
        },
    
        onClickDetailItem(value) {
            if (value.id) {
                if (value.route_type == 'org')
                    this.onClickMainOrganizationSelect(value)
                if (value.route_type == 'irs')
                    this.onClickDetailIrsSelect(value)
                if (value.route_type == 'sub')
                    this.onClickDetailSubSelect(value)
                if (value.route_type == 'intf')
                    this.onClickDetailInterfaceSelect(value)
            }
        },
    
        onClickTabOrganization(value) {
          this.show_tables = true;
          this.show_tables_org = false;
          this.show_tables_irs = false;
          this.show_tables_sub = false;
          this.show_tables_intf = false;
          this.show_tables_srv = false;
    
          if (value == 'org')
            this.show_tables_org = true;
          else if (value == 'irs')
            this.show_tables_irs = true;
          else if (value == 'sub')
            this.show_tables_sub = true;
          else if (value == 'intf')
            this.show_tables_intf = true;
          else if (value == 'srv')
            this.show_tables_srv = true;
        },
        onClickMainOrganizationSelect(value) {
            this.$router.push({ name: 'organization-detail-info', params: { id: value.id }, query: this.$config.query_params });
            this.onClickMainOrganizationInit();
        },
        onClickMainOrganizationInit(value) {
          window.scrollTo(0, 0);
    
          this.show_tables = false;
          this.show_detail_org = true;
          this.show_detail_irs = false;
          this.show_detail_sub = false;
          this.show_detail_intf = false;
          this.show_detail_srv = false;
          this.show_detail_itr = false;
          this.show_detail_server = false;
    
          this.clearTablesData();
        },
        onClickDetailIrsSelect(value) {
            this.$router.push({ name: 'information-resource-detail-info', params: { id: value.id }, query: this.$config.query_params });
            this.onClickDetailIrsInit();
        },
        onClickDetailIrsInit(value) {
            window.scrollTo(0, 0);
    
            this.show_tables = false;
            this.show_detail_org = false;
            this.show_detail_irs = true;
            this.show_detail_sub = false;
            this.show_detail_intf = false;
            this.show_detail_srv = false;
            this.show_detail_itr = false;
            this.show_detail_server = false;
    
            this.clearTablesData();
        },
        onClickDetailSubSelect(value) {
            this.$router.push({ name: 'subsystem-detail-info', params: { id: value.id }, query: this.$config.query_params });
            this.onClickDetailSubInit();
        },
        onClickDetailSubInit(value) {
          window.scrollTo(0, 0);
    
          this.show_tables = false;
          this.show_detail_org = false;
          this.show_detail_irs = false;
          this.show_detail_sub = true;
          this.show_detail_intf = false;
          this.show_detail_srv = false;
          this.show_detail_itr = false;
          this.show_detail_server = false;
    
          this.clearTablesData();
        },
        onClickDetailInterfaceSelect(value) {
            this.$router.push({ name: 'interface-detail-info', params: { id: value.id }, query: this.$config.query_params });
            this.onClickDetailInterfaceInit();
        },
        onClickDetailInterfaceInit(value) {
          window.scrollTo(0, 0);
    
          this.show_tables = false;
          this.show_detail_org = false;
          this.show_detail_irs = false;
          this.show_detail_sub = false;
          this.show_detail_intf = true;
          this.show_detail_srv = false;
          this.show_detail_itr = false;
          this.show_detail_server = false;
    
          this.clearTablesData();
        },
        onClickDetailSrvSelect(value) {
            this.$router.push({ name: 'service-detail-info', params: { id: value.id }, query: this.$config.query_params });
            this.onClickDetailSrvInit();
        },
        onClickDetailSrvInit(value) {
          window.scrollTo(0, 0);
    
          this.show_tables = false;
          this.show_detail_org = false;
          this.show_detail_irs = false;
          this.show_detail_sub = false;
          this.show_detail_intf = false;
          this.show_detail_srv = true;
          this.show_detail_itr = false;
          this.show_detail_server = false;
    
          this.clearTablesData();
        },
        onClickDetailItrSelect(value) {
            this.$router.push({ name: 'interaction-detail-info', params: { id: value.id }, query: this.$config.query_params });
            this.onClickDetailItrInit();
        },
        onClickDetailItrInit(value) {
          window.scrollTo(0, 0);
    
          this.show_tables = false;
          this.show_detail_org = false;
          this.show_detail_irs = false;
          this.show_detail_sub = false;
          this.show_detail_intf = false;
          this.show_detail_srv = false;
          this.show_detail_itr = true;
          this.show_detail_server = false;
    
          this.clearTablesData();
        },
        onClickDetailServerInit(value) {
          window.scrollTo(0, 0);
    
          this.show_tables = false;
          this.show_detail_org = false;
          this.show_detail_irs = false;
          this.show_detail_sub = false;
          this.show_detail_intf = false;
          this.show_detail_srv = false;
          this.show_detail_itr = false;
          this.show_detail_server = true;
    
          this.clearTablesData();
        },
    
        goto(refName) {
          var element = this.$refs[refName];
          var top = element.offsetTop;
    
          window.scrollTo(0, top);
        },
      }
    }
    </script>